<div id="notification-feed">
  <div class="notification-feed" id="mach-core-notification-feed-container">
    <div class="notification-feed__body" id="mach-core-notification-feed-body">
      <div class="tabs mt-[20px]" id="tabs-width-fixed-small"></div>
      @if (isAdvisories) {
        <div
          class="notification-feed__body-tab-link mt-[32px]"
          [ngClass]="{
            'notification-feed__body-tab-link-overflow':
              content.advisories.length > 3
          }"
          id="advisory-tab"
          role="tabpanel"
          aria-labelledby="advisory-tab-btn"
        >
          @if (content.advisories.length > 0) {
            <ul id="mach-core-notification-advisory-list">
              @for (
                advisory of content.advisories;
                track advisory;
                let isLast = $last
              ) {
                <li
                  class="notification-feed__body-advisory-list"
                  id="mach-core-notification-advisory-item-{{ $index }}"
                >
                  <a
                    [attr.href]="advisory.pageurl ? advisory.pageurl : '#'"
                    [attr.target]="
                      content &&
                      content.staticContent.advisoriesViewNewWindow === 'true'
                        ? '_blank'
                        : ''
                    "
                    class="notification-feed__body-advisory-container inline-block"
                    id="mach-core-notification-advisory-link-{{ $index }}"
                  >
                    <div
                      class="notification-feed__body-advisory-container-header text-label-sm-semibold text-heading mb-[4px]"
                    >
                      {{ advisory.title }}
                    </div>
                    @if (advisory.Description) {
                      <span
                        class="notification-feed__body-advisory-container-description text-body-xs text-body-copy mb-[4px] block"
                      >
                        {{ advisory.Description }}
                      </span>
                    }
                    <span
                      [ngClass]="{
                        'mb-[24px]': isLast
                      }"
                      class="notification-feed__body-advisory-container-timestamp text-caption-semibold text-body-copy mt-[4px] block"
                    >
                      {{ advisory.timestamp }}
                    </span>
                    @if (
                      content.staticContent.advisoriesViewNewWindow === 'true'
                    ) {
                      <span class="sr-only">
                        {{ content.staticContent.screenReaderOpenNewTabLabel }}
                      </span>
                    }
                  </a>
                  @if (!isLast) {
                    <div
                      class="w-[100%] border-[1px] border-stroke-01 my-[16px]"
                    ></div>
                  }
                </li>
              }
            </ul>
          } @else {
            <div class="empty-result" role="status">
              <span class="text-body-sm">
                {{ content.staticContent.noAdvisoriesLabel }}
              </span>
            </div>
          }
        </div>
      }
      @if (isNews) {
        <div
          class="notification-feed__body-tab-link mt-[32px]"
          id="news-tab"
          role="tabpanel"
          aria-labelledby="news-tab-btn"
        >
          @if (content.news.length > 0) {
            <ul id="mach-core-notification-news-list">
              @for (item of content.news; track item; let isLast = $last) {
                <li
                  [ngClass]="{ newsLastEle: isLast }"
                  class="notification-feed__body-advisory-list notification-feed__body-advisory-list--news"
                  id="mach-core-notification-news-item-{{ $index }}"
                >
                  <a
                    [attr.href]="item.link ? item.link : '#'"
                    [attr.target]="
                      content.staticContent &&
                      content.staticContent.newsViewNewWindow === 'true'
                        ? '_blank'
                        : ''
                    "
                    class="notification-feed__body-advisory-container inline-block"
                    id="mach-core-notification-news-link-{{ $index }}"
                  >
                    <div
                      [innerHTML]="item.title"
                      class="notification-feed__body-advisory-container-header text-label-sm-semibold text-heading mb-[4px]"
                    ></div>
                    <div
                      [ngClass]="{
                        'mb-[24px]': isLast
                      }"
                      class="notification-feed__body-advisory-container-timestamp news-timestamp text-caption-semibold text-body-copy mt-[4px] block"
                    >
                      {{ item.publishedTime }}
                    </div>
                    <span class="sr-only">
                      {{ content.staticContent.screenReaderOpenNewTabLabel }}
                    </span>
                  </a>
                  @if (!isLast) {
                    <div
                      class="w-[100%] border-[1px] border-stroke-01 my-[16px]"
                    ></div>
                  }
                </li>
              }
            </ul>
          } @else {
            @if (content.showEmptyMessageNews) {
              <div class="empty-result" role="status">
                <span class="text-body-sm">
                  {{ content.staticContent.noNewsLabel }}
                </span>
              </div>
            }
          }
        </div>
      }
    </div>
    <div
      class="notification-feed__body-footer"
      id="mach-core-notification-feed-footer"
    >
      @if (isAdvisories && content.advisories.length > 0) {
        <a
          [attr.href]="
            content.staticContent
              ? content.staticContent.advisoriesViewAllLink
              : '#'
          "
          class="advisories-view-all-link text-label-xs-semibold text-link"
          target="_blank"
          id="mach-core-notification-advisories-view-all"
        >
          <span aria-hidden="true">
            {{ content.staticContent.advisoriesViewAllLabel }}
          </span>
          <span class="sr-only">
            {{ content.staticContent.screenReaderViewAllAdvisories }}
          </span>
        </a>
      }
      @if (isNews && content.news.length > 0) {
        <a
          [attr.href]="
            content.staticContent ? content.staticContent.newsViewAllLink : '#'
          "
          class="news-view-all-link text-label-xs-semibold text-link"
          target="_blank"
          id="mach-core-notification-news-view-all"
        >
          <span aria-hidden="true">
            {{ content.staticContent.viewAllLabel }}
          </span>
          <span class="sr-only">
            {{ content.staticContent.screenReaderViewAllNews }}
          </span>
        </a>
      }
    </div>
    @if (
      selectedIndexPanel === 1 &&
      !content.showEmptyMessageNews &&
      content.news.length === 0
    ) {
      <div
        class="loading-container flex justify-center items-center"
        id="mach-core-notification-loading"
      >
        <div class="component-loader"></div>
      </div>
    }
  </div>
</div>
